import { Controller } from 'stimulus';

// Prefill VIP basic form from selected ALIS resident and store resident_id for server linking
export default class extends Controller {
  static values = {
    residents: Object,
  };

  connect() {
    this.onChange = this.onChange.bind(this);
    this.element.addEventListener('change', this.onChange);
  }

  disconnect() {
    this.element.removeEventListener('change', this.onChange);
  }

  onChange(event) {
    const residentId = event.target.value;
    if (!residentId) return;

    const resident = this.residentsValue?.[residentId];
    if (!resident) return;

    this.setValueById('vip_first_name', resident.firstName);
    this.setValueById('vip_last_name', resident.lastName);
    this.setValueById('vip_custom_name', resident.nickName);

    const dob = resident.dateOfBirth;
    if (dob) {
      const date = new Date(dob);
      if (!isNaN(date.getTime())) {
        this.setValueById('vip_date_of_birth_3i', String(date.getUTCDate()));
        this.setValueById(
          'vip_date_of_birth_2i',
          String(date.getUTCMonth() + 1)
        );
        this.setValueById(
          'vip_date_of_birth_1i',
          String(date.getUTCFullYear())
        );
      }
    }

    const sex = resident.sex || resident.gender;
    if (sex) {
      const select = document.getElementById('vip_sex');
      if (select) {
        const normalised = String(sex).toLowerCase();
        const value = normalised.startsWith('m')
          ? 'male'
          : normalised.startsWith('f')
          ? 'female'
          : '';
        if (Array.from(select.options).some((o) => o.value === value))
          select.value = value;
      }
    }
  }

  setValueById(id, value) {
    if (value == null) return;
    const el = document.getElementById(id);
    if (el) {
      el.value = value;
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
